import React, { useRef } from "react";
import { Grid, IconButton, Typography } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Controller } from "react-hook-form";

// The "نوع المرفق / تحميل الملف" rows: a paperclip per attachment type, and an eye to preview the chosen file.
// Each file is a react-hook-form field named `${namePrefix}${index}`, required when the type is mandatory.
const AttachmentUploadRows = ({ items, control, errors, namePrefix = "attachment", accept, onPick, onView }) => {
  const inputs = useRef({});

  const openPicker = (name) => {
    const input = inputs.current[name];
    if (!input) return;
    // Reset value so re-selecting the same file triggers onChange
    input.value = "";
    input.click();
  };

  return (
    <Grid container>
      {items.map((item, index) => {
        const name = `${namePrefix}${index}`;
        return (
          <React.Fragment key={item.attachmentTypeId || index}>
            {index === 0 && (
              <>
                <Grid sx={{ mb: 2 }} xs={6} md={3} item>
                  <Typography sx={{ fontWeight: "bold" }}>نوع المرفق</Typography>
                </Grid>
                <Grid xs={6} md={9} item>
                  <Typography sx={{ fontWeight: "bold" }}>تحميل الملف</Typography>
                </Grid>
              </>
            )}
            <Grid item xs={6} md={3}>
              <Typography>{`${item.attachmentType} ${item.isMandatory ? " *" : ""}`}</Typography>
            </Grid>
            <Grid item xs={6} md={9}>
              <Controller
                name={name}
                control={control}
                rules={{ required: item.isMandatory ? "هذا الحقل مطلوب" : false }}
                render={({ field }) => (
                  <>
                    <input
                      type="file"
                      id={name}
                      ref={(element) => {
                        inputs.current[name] = element;
                      }}
                      style={{ display: "none" }}
                      accept={accept}
                      onChange={(e) => onPick(field, e.target.files[0], index, name)}
                    />
                    <IconButton aria-label={`تحميل ${item.attachmentType}`} onClick={() => openPicker(name)}>
                      <AttachFileIcon />
                    </IconButton>
                    {field.value && !errors[name] && (
                      <IconButton aria-label={`استعراض ${item.attachmentType}`} onClick={() => onView(field.value)}>
                        <VisibilityIcon color={"primary"} />
                      </IconButton>
                    )}
                    {errors[name] && <Typography color="error">{errors[name].message}</Typography>}
                  </>
                )}
              />
            </Grid>
          </React.Fragment>
        );
      })}
    </Grid>
  );
};

export default AttachmentUploadRows;
